module.exports = __webpack_public_path__ + "img/currency4.bea8f118.png";